import React, { useState, useEffect } from "react";
import Box from "@material-ui/core/Box";
import { TextField, MuiThemeProvider, Typography, Button, FormHelperText } from "@material-ui/core";
import theme from "../shared/ManageUsersTheme";
import { makeStyles } from "@material-ui/core/styles";
import { useForm, Controller } from "react-hook-form";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import MenuItem from "@material-ui/core/MenuItem";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from "@material-ui/core/Select";
import Radio from "@material-ui/core/Radio";
import { consts } from "../../common/consts";
import { useHistory } from "react-router-dom";
import InputAdornment from "@material-ui/core/InputAdornment";
import { getPasswordStrength, PasswordStrength } from "../../common/utility";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import api from "../../store/api";
import Navbar from "../shared/Navbar";
import LinearProgress from "@material-ui/core/LinearProgress";
import { useDispatch, useSelector } from "react-redux";
import { showNavbar } from "../../store/modules/appStateSlice";
import { ArrowIcon, StarIcon } from "../../assets/iconComponents/Icons";
import Paper from "@material-ui/core/Paper";
import Alert from "@material-ui/lab/Alert";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Checkbox from '@material-ui/core/Checkbox';
import Skeleton from '@material-ui/lab/Skeleton';
import { RootState } from '../../store/rootReducer';

interface ISelectItem extends React.Props<any> {
  text: string | undefined;
  value: string | undefined;
  selected: boolean;
  disabled: boolean | undefined;
}

interface AddEditUserProps {
  userId?: string | null;
}
interface ProfilePermission {
  userProfilePermissionId: string,
  applicationPermissionId: string,
  userProfileId: string,
  createdBy: string,
  modifiedBy: string,
  applicationPermissionName: string,
  checked: boolean | null,
  isAdmin: boolean | null,
  scope: number | null,
  categoryId: string,
  categoryName: string,
  appPermissionRequireScope: boolean | null,
  appPermissionIsInternal: boolean | null,
  appPermDisplayName: string,
  appPermDescription: string,
  role: string,
  subName: string,
};
interface ProfileProps {
  userProfileId: string,
  name: string,
  createdOn: string,
  modifiedOn: string,
  createdBy: string,
  modifiedBy: string,
  deleted: boolean,
  customerLocationId: string,
  selected: boolean,
  idleTimeInMinutes: string,
  logOutTimeOutInMinutes: string,
  checked: boolean | null,
};

const useStyles = makeStyles({
  baseMargin: {
    marginLeft: 60,
  },
  userType: {
    width: "40%",
  },
  userForm: {
    width: "60%",
    marginLeft: 30,
  },
  body2: {
    marginLeft: 30,
  },
  input: {
    height: 43,
    backgroundColor: "#ECECEC",
  },
  greenButon: {
    backgroundColor: "#00a348",
    fontSize: 12,
    color: "#FFF",
    padding: "0px 7px",
    "&:hover": {
      backgroundColor: "#00a348",
    },
  },
  mainGrid: {
    width: "100%",
    paddingLeft: 40,
    paddingRight: 40,
  },
  mainTop: {
    marginTop: 40,
    marginLeft: 60,
    marginBottom: 20,
  },
  removeHover: {
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  textFieldLable: {
    fontSize: 15,
    color: "#949494",
    padding: theme.spacing(0, 0, 1, 0),
    fontWeight: "bold",
  },
  heading: {
    fontSize: 36,
    fontWeight: 900,
    padding: theme.spacing(0, 0, 2, 0),
  },
  main: {},
  textFieldRoot: {
    width: "100%",
    fontWeight: "bold",
  },
  textFieldInput: {
    backgroundColor: "#ECECEC",
    color: "black",
    height: "40px",
  },
  selectField: {
    backgroundColor: "#ECECEC",
    height: 40,
  },
  helpText: {
    color: "red",
    padding: theme.spacing(0, 0, 0, 2),
  },
  infoText: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    padding: theme.spacing(0, 0, 0, 2),
    color: "#02489D",
    cursor: "pointer"
  },
  profilePermissionCheckbox: {
    "& .Mui-disabled":
    {
      color: "#000"
    },
    "& span:nth-child(2)": {
      fontWeight: 400
    },

  },
  saveBtn: {
    margin: theme.spacing(0, 1, 0, 1),
    width: 95,
    height: 42,
    backgroundColor: "#02489D",
    color: "#FFF",
    fontWeight: 700,
    fontSize: 15,
    borderRadius: 6,
  },
  cancelBtn: {
    margin: theme.spacing(0, 1, 0, 1),
    width: 95,
    height: 42,
    color: "#333333",
    fontWeight: 700,
    fontSize: 15,
    borderRadius: 6,
  },
  formLeft: {
    marginLeft: 60,
    marginBottom: 40,
    marginTop: 40,
  },
  backBtn: {
    fontSize: 18,
    fontWeight: 700,
    color: "#02489D",
    position: "relative",
    top: -2,
  },
  loading: {
    width: "100%",
  },
  headingAlert: {
    padding: theme.spacing(0, 0, 2, 0),
  },
  alertRoot: {
    marginTop: 24,
    paddingBottom: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  alertErrorRoot: {
    marginLeft: 40,
    marginRight: 40,
    marginBottom: 40,
    marginTop: 40
  },
  btnContainer: {
    display: "flex",
    justifyContent: "space-between"
  },
  changePasswordBtn: {
    margin: theme.spacing(5, 3, 0, 0),
    height: 42,
    color: "#333333",
    fontWeight: 700,
    fontSize: 15,
    borderRadius: 6,
  }
});

const HorizontalLine = () => {
  return (
    <hr
      style={{
        height: 0,
        borderTop: "1px solid #979797",
        marginTop: 50,
      }}
    />
  );
};

const cg_handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
  event.preventDefault();
};
interface SelectItem extends React.Props<any> {
  text: string | undefined,
  value: string | undefined,
  selected: boolean,
  disabled: boolean | undefined
};
const AddEditUserWidget = (props: AddEditUserProps): JSX.Element => {
  const userId = props.userId;
  const history = useHistory();
  const [isIndividualAccount, setIsIndividualAccount] = useState(true);
  const classes = useStyles();
  const { handleSubmit, errors, control, setError, setValue, getValues } = useForm();
  const [userStatus, setUserStatus] = useState(true);
  const [resetpasswordStrength, setResetPasswordStrength] = useState<PasswordStrength>(PasswordStrength.none);
  const [passwordStrength, setPasswordStrength] = useState<PasswordStrength>(PasswordStrength.none);
  const [errorMessage, setErrorMessage] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [cg_showPassword, cg_setShowPassword] = useState(false);
  const [profileList, setProfileList] = useState<ISelectItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [loadingBar, setLoadingBar] = useState(false);
  const dispatch = useDispatch();
  const editUser = userId ? true : false;
  const [open, setOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [profileDialogOpen, setProfileDialogOpen] = useState(false);
  const [profilePermissionInfoLoaded, setProfilePermissionInfoLoaded] = useState(false);
  const [profileFeaturesList, setProfileFeaturesList] = useState<ProfilePermission[]>([]);
  const [showConfirmedPassword, setShowConfirmedPassword] = useState(false);
  const [errorMessagePassword, setErrorMessagePassword] = useState(false);
  const [showProfileInfo, setShowProfileInfo] = useState(false);
  const [wardList, setWardList] = useState<ISelectItem[]>([]);
  const { handleSubmit: handleSubmit_cg, watch: watch_cg, errors: errors_cg, control: control_cg, setValue: setValue_cg, getValues: getValues_cg } = useForm();
  let passwordWatch = watch_cg('cg_password');
  const { authStore } = useSelector((state: RootState) => state);
  const [enable2FA, setEnable2FA] = useState(false);
  const [profileListManageuser, setProfileListManageuser] = useState<ProfileProps[]>([]);
  const [locationList, setLocationList] = useState<SelectItem[]>([]);
  const [locationListhidden, setLocationListhidden] = useState<boolean>(false);
  const [wardhidden, setwardhidden] = useState<boolean>(false);
  const [ward, setward] = useState();
  const goToUsers = () => {
    history.goBack();
  };

  const accountChangeClick = () => {
    if (!editUser) {
      setIsIndividualAccount(!isIndividualAccount);
    }
  };

  const updatePasswordStrengthLabel = (type: string) => {
    let fontColor = "red";
    if (passwordStrength === PasswordStrength.moderate || resetpasswordStrength === PasswordStrength.moderate) {
      fontColor = "orange";
    }
    if (passwordStrength === PasswordStrength.good || resetpasswordStrength === PasswordStrength.good) {
      fontColor = "green";
    }
    return type == "main" ? <label style={{ color: fontColor }}> {passwordStrength} </label> : <label style={{ color: fontColor }}> {resetpasswordStrength} </label>;
  };

  const GeneratePassword = (type: string): JSX.Element => {
    return (
      <div className="rowC">
        <div className="hintText">
          Password Strength:
          <span className="hintPassword">{updatePasswordStrengthLabel(type)}</span>
        </div>
        <div className="rightAlignContainer">
          <Button className="passwordBtn" color="primary" onClick={generatePassword}>
            Generate Password
          </Button>
        </div>
      </div>
    );
  };

  const cg_handleClickShowPassword = () => {
    cg_setShowPassword(!cg_showPassword);
  };

  const generatePassword = async (): Promise<void> => {
    setErrorMessage("");
    setStatusMessage("");
    await api
      .generatePassword("")
      .then((_res) => {
        if (_res !== null && _res.data !== null && _res.data.password !== null) {
          if (!open) {
            setValue("password", _res.data.password);
            setPasswordStrength(getPasswordStrength(_res.data.password));
            updatePasswordStrengthLabel("main");
          }
          else {
            setValue_cg('cg_password', _res.data.password);
            setValue_cg('cg_confirmedPassword', _res.data.password);
            setResetPasswordStrength(getPasswordStrength(_res.data.password));
            updatePasswordStrengthLabel('edit');
          }
        }
      })
      .catch((error) => {
        setErrorMessage(error);
      });
  };

  const CreateLoadingLine = (props: any): JSX.Element => {
    return (
      <div className={classes.loading}>
        <LinearProgress color="primary" />
      </div>
    );
  };

  const addUser = async () => {
    setLoading(true);
    let values = getValues();
    let req: any = {};
    if (isIndividualAccount) {
      req = {
        firstname: values["firstName"],
        lastName: values["lastName"],
        emailAddress: values["emailAddress"],
        employeeId: parseInt(values['employeeId']),
        username: values["emailAddress"],
        userProfileId: values["userProfileId"],
        phoneNumber: values["phoneNumber"],
        inviteUser: true,
        isSharedUser: false,
        isEnabled: userStatus,
        isLockedOut: false,
        deleted: null,
        enable2FA: enable2FA,
        CustomerId:authStore.data?.CustomerId||"00000000-0000-0000-0000-000000000000"
      };
      if (values["wardId"] && values["wardId"] !== "") {
        req.wardId = values["wardId"];
      }
      if (values["locationId"] && values["locationId"] !== "") {
        req.locationId = values["locationId"];
      }
      if(!authStore.data?.IsCustomer){
        req.locationId = authStore.data?.location;
      }
    } else {
      req = {
        firstname: values["firstName"],
        lastName: values["lastName"],
        emailAddress: values["emailAddress"],
        employeeId: parseInt(values['employeeId']),
        username: values["emailAddress"],
        userProfileId: values["userProfileId"],
        password: values["password"],
        inviteUser: false,
        isSharedUser: true,
        isEnabled: userStatus,
        isLockedOut: false,
        deleted: null,
        enable2FA: enable2FA,
        CustomerId:authStore.data?.CustomerId||"00000000-0000-0000-0000-000000000000"
      };
      if (values["wardId"] && values["wardId"] !== "") {
        req.wardId = values["wardId"];
      }
      if (values["locationId"] && values["locationId"] !== "") {
        req.locationId = values["locationId"];
      }
    }
    await api.addNewUserLocation("", req).then((res) => {
      if (!res.hasError && res.message !== null) {
        setStatusMessage(res.message);
        goToUsers();
      } else {
        setErrorMessage(res.message ?? "");
        setLoading(false);
      }
    }).catch(error => {
      setErrorMessage('Error while adding user: ' + error);
      setLoading(false);
    });
  };

  const updateUser = async (): Promise<void> => {
    setLoading(true);
    let values = getValues();
    let req: { [index: string]: any } = {
      userId: userId,
      firstName: values["firstName"],
      lastName: values["lastName"],
      phoneNumber: values["phoneNumber"].replaceAll(' ', '').replaceAll('-', ''),
      emailAddress: values["emailAddress"],
      employeeId: parseInt(values['employeeId']),
      userProfileId: values["userProfileId"],
      isEnabled: userStatus ? true : false,
      enable2FA: enable2FA
    };
    if (values["wardId"] && values["wardId"] !== "") {
      req.wardId = values["wardId"];
    }
    if (values["locationId"] && values["locationId"] !== "") {
      req.locationId = values["locationId"];
    }
    if(!authStore.data?.IsCustomer){
      req.locationId = authStore.data?.location;
    }
    await api
      .updateUserLocation("", req)
      .then((res) => {
        if (!res.hasError && res.message !== null) {
          setStatusMessage(res.message);
          setLoading(false);
        } else {
          setErrorMessage(res.message);
          setLoading(false);
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        setLoading(false);
      });
  };

  // get user data
  const getAddUserData = async (): Promise<void> => {
    try {
      setLoadingBar(true);
      const _res = await api.getAddUserDataLocation("");
      if (_res !== null && _res.data !== null && _res.data.model !== null) { 
        if(authStore.data?.CustomerId)
        {
          setLocationListhidden(true);
          getLocationsPerCustomer();
        } 
        if(authStore.data?.location !== "" && authStore.data?.location !== null)
        {
          setLocationListhidden(false);
          let Locationid = authStore.data?.location ?? null;
          getWardsPerLocations(Locationid);
        }
        // else{
        //   setWardList(_res.data.model.wards);
        // }
        if(authStore.data?.ward === "")
        {
          setwardhidden(true);
        }
        setProfileList(_res.data.model.profiles);      
        setLoadingBar(false);
      }
    }
    catch (error) {
      setErrorMessage('Error when adding user');
      setProfileList([]);
      setWardList([]);
      setLoading(false);
      setLoadingBar(false);
    }
  };

  const getEditUserData = async () => {
    try {
      const res = await api.getEditUserDataLocation("userId=" + userId);
      if (res !== null && res.data !== null && res.data.model !== null) {        
        if(authStore.data?.CustomerId)
        {
          setLocationListhidden(true);
          getLocationsPerCustomer();
        } 
        if(authStore.data?.location !== "" && authStore.data?.location !== null)
        {
          setLocationListhidden(false);
          let Locationid = authStore.data?.location ?? null;
          getWardsPerLocations(Locationid);
        }
        if(authStore.data?.ward === "")
        {
          setwardhidden(true);
        }
        setProfileList(res.data.model.profiles);     
        if(res.data.model.locationId!== null)
        {
          getWardsPerLocations(res.data.model.locationId);
        }
        // else{
        //   getward( res.data.model.userProfileId);
        // }    
        let fields = ["firstName", "lastName", "emailAddress", "phoneNumber", "userProfileId", "isEnabled", "isSharedUser", "wardId", "enable2FA","locationId"];
        for (let field in fields) {
          let fieldName = fields[field];
          if (fieldName == "isEnabled") {
            setUserStatus(res.data.model[fieldName]);
          } else if (fieldName == "isSharedUser") {
            setIsIndividualAccount(!res.data.model[fieldName]);
          } else if (fieldName == "enable2FA") {
            setEnable2FA(res.data.model[fieldName] ?? false);
          }
          else if (fieldName == "wardId") {
            setward(res.data.model[fieldName]);
            setValue("wardId",res.data.model[fieldName])
          } else {
            setValue(fieldName, res.data.model[fieldName]);
            if (fieldName === "userProfileId" && res.data.model[fieldName]) {
              setShowProfileInfo(true);
              //getward( res.data.model[fieldName])
            }
          }
        }
        let values = getValues();      
        if(values["wardId"] === "" || values["wardId"] === null)
        {
          setValue("wardId","");
        }
        if(values["locationId"] === "" || values["locationId"] === null)
        {
          setValue("locationId","");
        }
      }
    }
    catch (error) {
      setErrorMessage('Error when editing user');
      setProfileList([]);
      setWardList([]);
      setLoading(false);
    }
  };
  const getward = async(userProfileId:any) =>{
    try{
      const res = await api.getwardbyuserprofile("Userprofileid=" + userProfileId);
      if (res.hasError === false) {
        setWardList(res.result);
      }
    }
    catch (error) {
      setErrorMessage('Error when editing user');
      setProfileList([]);
      setWardList([]);
      setLoading(false);
    }
  }
  const changePassword = async (): Promise<void> => {
    setErrorMessage("");
    setStatusMessage("");
    setLoading(true);
    let values = getValues_cg();
    if (!userId) {
      setStatusMessage('Error while finding userId');
    }
    let _req: { [index: string]: any } = { userId: userId, password: values['cg_password'] };

    if (authStore?.data?.IsAdmin) {
      await api.changePassword('', _req)
        .then(res => {
          if (!res.hasError) {
            handleClose();
          }
          if (res.message !== null)
            setStatusMessage(res.message);
          setLoading(false);
        })
        .catch(error => {
          setErrorMessagePassword(error);
          setLoading(false);
        })
    } else {
      await api.changePasswordLocation('', _req)
        .then(res => {
          if (!res.hasError) {
            handleClose();
          }
          if (res.message !== null)
            setStatusMessage(res.message);
          setLoading(false);
        })
        .catch(error => {
          setErrorMessagePassword(error);
          setLoading(false);
        })
    }
    setLoading(false);
  }

  const handleOpen = () => {
    setOpen(true);
    resetMessages();
  };

  const resetMessages = () => {
    setErrorMessage('');
    setStatusMessage('');
  }

  const handleClose = () => {
    setOpen(false);
    setResetPasswordStrength(PasswordStrength.none);
    updatePasswordStrengthLabel('edit');
    resetMessages();
    setShowConfirmedPassword(false)
    setShowPassword(false)
  };

  useEffect(() => {
    dispatch(showNavbar(false));
    setLoading(true);
    if (userId) {
      getEditUserData();
    } else {
      getAddUserData();
    }
    setLoading(false);
  }, []);
  const handleProfileInfoClick = () => {
    setProfileDialogOpen(true);
    if (!profilePermissionInfoLoaded) {
      let values = getValues();

      api.getProfileAllowedPermissions('profileId=' + values["userProfileId"])
        .then(res => {
          if (res !== null && res.data !== null && res.data.model !== null) {
            let _permsList: ProfilePermission[] = res.data.model;
            if (_permsList !== null) {

              setProfileFeaturesList(_permsList);
              getProfilesManageuser(values["userProfileId"]);
            }
            else {
              setProfileFeaturesList([]);
            }
            setProfilePermissionInfoLoaded(true);
          }
        })
        .catch(error => {
          alert("An error occured while loading profile");
        });

    }
  };
  const handleUserProfileDialogClose = () => {
    setProfileDialogOpen(false);
  }
  const getProfilesManageuser = (profileId: any): void => {
    let profileList: ProfileProps[] = [];
    api.getUsermanageuser('profileId=' + profileId)
      .then(res => {
        setProfileListManageuser([]);
        if (res !== null && res.data !== null && res.data.model !== null) {
          profileList = res.data.model;
          setProfileListManageuser(profileList);
        }
        else {
          setProfileListManageuser([]);
        }
      })
      .catch(error => {
        setProfileList([]);
        setErrorMessage('Error while getting profiles: ' + error);
      });

  }
  //body color header
  const Heading = ({ text, color }: any) => {
    return (
      <div style={{ color: color, fontWeight: 900, fontSize: 18 }}>{text}</div>
    )
  }
  //body feature description
  const Description = ({ text }: any) => {
    return (
      <div style={{ color: '#7D7D7D', fontSize: 14, paddingLeft: 28 }}>{text}</div>
    )
  }
  const getSelectedProfileName = () => {
    let values = getValues();
    let selectedProfile = profileList.find(p => p.value === values["userProfileId"]);
    if (selectedProfile) {
      return selectedProfile.text;
    }
    else {
      return null;
    }
  }

  const validateUserProfile = async (value: string): Promise<boolean | string> => {
    let values = getValues();
    if (value === "None" || value === "") {
      return "User Profile is required";
    } else {
      if (values["wardId"]) {
        return true;
      }
      else {
        let _permsList: ProfilePermission[] = [];
        if (!profilePermissionInfoLoaded) {
          let res = await api.getProfileAllowedPermissions('profileId=' + value);
          if (res !== null && res.data !== null && res.data.model !== null) {
            _permsList = res.data.model;
            if (_permsList !== null) {

              setProfileFeaturesList(_permsList);

            }
            else {
              setProfileFeaturesList([]);
            }
            setProfilePermissionInfoLoaded(true);
          }
        }
        else {
          _permsList = profileFeaturesList;
        }
        if (_permsList.filter(p => p.appPermissionRequireScope && p.scope === 1).length == 0) {
          return true;
        }
        return true;
        // else {
        //     setError("wardId", {
        //         type: "validate",
        //         message: "The user profile selected requires a ward to be selected"

        //     });
        //     return true;
        // }
      }
    }
  }
  const validateWard = async (value: string): Promise<boolean | string> => {
    let values = getValues();
    if (value && value !== "None") {
      return true;
    }
    else {
      if (!values["userProfileId"] || values["userProfileId"] === "None") {
        return true;
      }
      let _permsList: ProfilePermission[] = [];
      if (!profilePermissionInfoLoaded) {
        let res = await api.getProfileAllowedPermissions('profileId=' + values["userProfileId"]);
        if (res !== null && res.data !== null && res.data.model !== null) {
          _permsList = res.data.model;
          if (_permsList !== null) {

            setProfileFeaturesList(_permsList);

          }
          else {
            setProfileFeaturesList([]);
          }
          setProfilePermissionInfoLoaded(true);
        }
      }
      else {
        _permsList = profileFeaturesList;
      }
      if (_permsList.filter(p => p.appPermissionRequireScope && p.scope === 1).length == 0) {
        return true;
      }
      else {
        return "The user profile selected requires a ward to be selected";

      }
    }
  }
  const selectChangedHandler = (value: any, filedName: string) => {
    let pickValue = value;
    setValue('locationId', value);
    if (pickValue !== "") {
      //getProfilesPerLocation(value);
      setValue("wardId","");
      setWardList([]);
      getWardsPerLocations(value);
    }

  }
  const getLocationsPerCustomer = async (): Promise<void> => {
    const _res = await api.getLocationsPerCustomer('customerId=' + authStore.data?.CustomerId);
    if (_res !== null && _res.data !== null && _res.data.model !== null) {
      setLocationList(_res.data.model);
      setLoading(false);
      resetMessages();
    } else if (_res.data.errorRaised) {
      setLoading(false);
      resetMessages();
    }
  }
  const getWardsPerLocations = async (locationId: string | null): Promise<void> => {
    const _res = await api.getWardsInLocation('locationId=' + locationId);
    if (_res !== null && _res.data !== null && _res.data.model !== null) {
      setWardList(_res.data.model);
      setLoading(false);
      resetMessages();
    } else if (_res.data.errorRaised) {
      setLoading(false);
      resetMessages();
    }
  }
  return (
    <React.Fragment>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth="sm"
      >
        <DialogTitle id="form-dialog-title">Change Password</DialogTitle>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <form
          onSubmit={handleSubmit_cg(changePassword)}
          autoComplete="off"
          id="changePasswordForm"
        >
          <DialogContent>
            <div>
              <div className={classes.textFieldLable}>
                <span>
                  <StarIcon />
                </span>
                PASSWORD
              </div>
              <Controller
                defaultValue=""
                control={control_cg}
                render={({ onChange, onBlur, value, name }) => (
                  <TextField
                    classes={{ root: classes.textFieldRoot }}
                    InputProps={{
                      classes: {
                        root: classes.textFieldInput,
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            style={{ color: "#000" }}
                            aria-label="toggle password visibility"
                            onClick={() => { setShowPassword(!showPassword) }}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    onBlur={onBlur}
                    value={value}
                    name={name}
                    onChange={(e) => {
                      let pwdStrength = getPasswordStrength(e.target.value);
                      setResetPasswordStrength(pwdStrength);
                      onChange(e);
                    }}
                    variant="outlined"
                    type={showPassword ? "text" : "password"}
                    error={errors_cg.cg_password}
                    helperText={errors_cg.cg_password ? errors_cg.cg_password.message : ""}
                  />
                )}
                name="cg_password"
                rules={{
                  required: "Password is required",
                  validate: (value) => {
                    let pwdStrength = getPasswordStrength(value);
                    if (pwdStrength !== PasswordStrength.good) {
                      setErrorMessagePassword(true);
                      return false;
                    } else {
                      setErrorMessagePassword(false);
                      return true;
                    }
                  },
                }}
              />
            </div>
            {GeneratePassword("edit")}
            <div>
              <div className={classes.textFieldLable}>
                <span>
                  <StarIcon />
                </span>
                CONFIRMED PASSWORD
              </div>
              <Controller
                defaultValue=""
                control={control_cg}
                as={
                  <TextField
                    classes={{ root: classes.textFieldRoot }}
                    InputProps={{
                      classes: {
                        root: classes.textFieldInput,
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            style={{ color: "#000" }}
                            aria-label="toggle password visibility"
                            onClick={() => setShowConfirmedPassword(!showConfirmedPassword)}
                          >
                            {showConfirmedPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    variant="outlined"
                    type={showConfirmedPassword ? "text" : "password"}
                    error={errors_cg.cg_confirmedPassword}
                    helperText={
                      errors_cg.cg_confirmedPassword
                        ? errors_cg.cg_confirmedPassword.message
                        : ""
                    }
                  />
                }
                name="cg_confirmedPassword"
                rules={{
                  required: "Confirmed Password is required",
                  validate: (value) => {
                    if (passwordWatch === value) {
                      return true;
                    } else {
                      return "Confirmed Password does not match";
                    }
                  },
                }}
              />
            </div>
          </DialogContent>

          {errorMessagePassword ? (
            <div>
              <Alert
                variant="filled"
                icon={<ReportProblemOutlinedIcon />}
                severity="error"
                className={classes.alertErrorRoot}
              >
                Please enter a stronger password to continue. Try making your password
                longer, adding special characters (!@#$%^^&*), adding numbers and
                using upper case letters.
              </Alert>
            </div>
          ) : null}

          <DialogActions>
            <div className="divModalBtn">
              <Button className="modalBtn" variant="contained" onClick={handleClose}>
                Cancel
              </Button>
              <Button
                className="modalBtn"
                variant="contained"
                color="primary"
                type="submit"
              >
                Save
              </Button>
            </div>
          </DialogActions>
        </form>
      </Dialog>
      <MuiThemeProvider theme={theme}>
        <Navbar />
        {loadingBar ? <CreateLoadingLine /> : null}
        <Paper
          style={ loadingBar ? {
            height: "100%",
            overflowY: "scroll",
            minWidth: 1024,
            paddingBottom: 50,
            borderRadius: 0,
            pointerEvents: "none", opacity: "0.6"
          } : {
            height: "100%",
            overflowY: "scroll",
            minWidth: 1024,
            paddingBottom: 50,
            borderRadius: 0
          }}
        >
          <Box>
            <form onSubmit={handleSubmit(editUser ? updateUser : addUser)}>
              <div className={classes.mainTop}>
                <IconButton className={classes.removeHover} size="small" onClick={goToUsers}>
                  <ArrowIcon />
                  <span className={classes.backBtn}>Users</span>
                </IconButton>
              </div>
              <Box>
                <Typography variant="h2" className={classes.baseMargin}>
                  {userId ? "Edit User" : "New User"}
                </Typography>
              </Box>
              <Box className={classes.baseMargin}>
                <Grid container>
                  <Grid item md={6} lg={5}>
                    <Box style={{ opacity: editUser ? 0.5 : undefined }}>
                      <RadioGroup onChange={accountChangeClick}>
                        <Box my={3}>
                          <Typography variant="subtitle1">Account Type</Typography>
                        </Box>
                        <Box>
                          <FormControlLabel value="individualAccount" control={<Radio color="primary" />} label="Individual Account" checked={isIndividualAccount} />

                          <Box className={classes.body2}>
                            <Button size="small" className={classes.greenButon}>
                              RECOMMENDED
                            </Button>
                            <Typography variant="body2">For optimum security, individual account is recommended. You will only need to enter minimal details. The user will then be invited to enter their details and choose a password.</Typography>
                          </Box>
                        </Box>
                        <Box mt={2}>
                          <FormControlLabel value="sharedAccount" control={<Radio color="primary" />} label="Shared Account" checked={!isIndividualAccount} />
                          <Box className={classes.body2}>
                            <Typography variant="body2">In some cases, shared accounts are the only way to give users an account. In this case, you will be asked to supply all the details and choose a password. Users of shared accounts are prevented from resetting the account's password.</Typography>
                          </Box>
                        </Box>
                      </RadioGroup>
                    </Box>
                  </Grid>

                  <Grid item md={6} lg={5}>
                    <Box>
                      <Box>
                        <Grid className={classes.mainGrid} container spacing={3}>
                          <Grid item xs={12}>
                            <div className={classes.main}></div>
                          </Grid>
                          <Grid item xs={6}>
                            <div className={classes.textFieldLable}>
                              <span>
                                <StarIcon />
                              </span>
                              FIRST NAME
                            </div>
                            <Controller
                              control={control}
                              as={
                                <TextField
                                  classes={{ root: classes.textFieldRoot }}
                                  InputProps={{
                                    classes: { root: classes.textFieldInput },
                                  }}
                                  variant="outlined"
                                  error={errors.firstName}
                                  helperText={errors.firstName ? errors.firstName.message : ""}
                                />
                              }
                              name="firstName"
                              defaultValue=""
                              rules={{
                                required: "First Name is required",
                              }}
                            />
                          </Grid>

                          <Grid item xs={6}>
                            <div className={classes.textFieldLable}>LAST NAME</div>
                            <Controller
                              control={control}
                              as={
                                <TextField
                                  classes={{ root: classes.textFieldRoot }}
                                  InputProps={{
                                    classes: { root: classes.textFieldInput },
                                  }}
                                  variant="outlined"
                                  error={errors.lastName}
                                  helperText={errors.lastName ? errors.lastName.message : ""}
                                />
                              }
                              name="lastName"
                              defaultValue=""
                            />
                          </Grid>                       
                          <Grid item xs={12}>
                            <div className={classes.textFieldLable}>
                              <span>
                                <StarIcon />
                              </span>
                              USER PROFILE
                            </div>
                            <Controller
                              name="userProfileId"
                              defaultValue=""
                              control={control}
                              render={({ onChange, onBlur, value, name }) => (
                                <div>
                                  <Select
                                    error={errors.userProfileId}
                                    IconComponent={KeyboardArrowDownIcon}
                                    onChange={(e) => {
                                      let values = getValues();
                                      if (e.target.value) {                                        
                                        setShowProfileInfo(true);
                                        setProfilePermissionInfoLoaded(values["userProfileId"] === e.target.value);
                                        // if(!authStore.data?.IsCustomer)
                                        // {
                                        //     setWardList([]);
                                        //     getward(e.target.value);
                                        // }                   
                                        // if(!locationListhidden)
                                        // {
                                        //   setWardList([]);
                                        //   getward(e.target.value);
                                        // }                  
                                      }
                                      else {
                                        setShowProfileInfo(false);
                                        setProfileDialogOpen(false);
                                        setProfilePermissionInfoLoaded(false);
                                        setValue("wardId","");
                                        setWardList([]);
                                      }

                                      setValue("userProfileId", e.target.value);
                                      onChange(e);
                                    }}                                 
                                    className={classes.selectField}
                                    value={value}
                                    displayEmpty
                                    defaultValue=""
                                    fullWidth={true}
                                    variant="outlined"
                                  >
                                    <MenuItem key="None" value={""}>
                                      Choose User Profile
                                    </MenuItem>
                                    {profileList.map((item) => (
                                      <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>
                                        {item.text}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  {showProfileInfo ?
                                    <FormHelperText className={classes.infoText} onClick={handleProfileInfoClick}><InfoOutlinedIcon fontSize="small" style={{ paddingRight: 5 }} />About this profile</FormHelperText>
                                    : null}
                                  <FormHelperText className={classes.helpText}>{errors.userProfileId ? errors.userProfileId.message : ""}</FormHelperText>
                                  <Dialog onClose={handleUserProfileDialogClose} maxWidth="sm" fullWidth open={profileDialogOpen}>
                                    <DialogTitle id="profile-dialog-title">
                                      User Privileges - {getSelectedProfileName()}
                                    </DialogTitle>
                                    <IconButton
                                      aria-label="close"
                                      className={classes.closeButton}
                                      onClick={handleUserProfileDialogClose}
                                    >
                                      <CloseIcon />
                                    </IconButton>
                                    <DialogContent dividers>

                                      {
                                        profilePermissionInfoLoaded ?
                                          <React.Fragment>
                                            {profileFeaturesList.filter(p => p.categoryName === "Admin Features").length > 0 ?
                                              <div style={{ borderLeft: '4px solid #577C6D', paddingLeft: 20, marginTop: 30 }}>
                                                <Heading text="ADMIN FEATURES" color="#577C6D" />
                                                {profileFeaturesList.filter(p => p.categoryName === "Admin Features" && p.role !== "ManageUsers").map((perm, i) =>
                                                  <div key={perm.applicationPermissionId}>
                                                    <FormControlLabel
                                                      className={classes.profilePermissionCheckbox}
                                                      control={<Checkbox
                                                        style={{ padding: 4 }}
                                                        checked={true}
                                                        disabled />}
                                                      label={perm.appPermDisplayName}
                                                    />
                                                    <Description text={perm.appPermDescription} />
                                                    {
                                                      perm.appPermissionRequireScope ?
                                                        <div style={{ paddingLeft: 28 }}>
                                                          <label>{perm.scope == 1 ? "For user's ward only" : "For any ward in hospital"}</label>
                                                        </div> : null
                                                    }
                                                    {
                                                      perm.applicationPermissionName === "ManageUsers" ?
                                                        profileFeaturesList.filter(p => p.categoryName === "Admin Features" && p.role === "ManageUsers").map((perms, i) =>
                                                          <div style={{ paddingLeft: 28 }}>
                                                            <label>{perms.scope == 2 ? "Having any user profiles" : "Having selected user profiles"}</label>
                                                          </div>
                                                        )
                                                        : null
                                                    }
                                                    {
                                                      perm.applicationPermissionName === "ManageUsers" && (profileListManageuser !== undefined) ?
                                                        profileListManageuser.map((perms, i) =>
                                                          <div className={"body"}>
                                                            <div className={"list"} style={{ marginLeft: "31px" }}>
                                                              <FormControlLabel
                                                                className={classes.profilePermissionCheckbox}
                                                                control={<Checkbox
                                                                  style={{ padding: 4 }}
                                                                  checked={true}
                                                                  disabled />}
                                                                label={perms.name}
                                                              />
                                                            </div>
                                                          </div>
                                                        )
                                                        : null
                                                    }
                                                  </div>
                                                )}

                                              </div> : null}
                                            {profileFeaturesList.filter(p => p.categoryName === "Patient Transport Features").length > 0 ?
                                              <div style={{ borderLeft: '4px solid #AE72C0', paddingLeft: 20, marginTop: 30 }}>
                                                <Heading text="PATIENT TRANSPORT FEATURES" color="#AE72C0" />

                                                {profileFeaturesList.filter(p => p.categoryName === "Patient Transport Features").map((perm, i) =>
                                                  <div key={perm.applicationPermissionId}>
                                                    <FormControlLabel
                                                      className={classes.profilePermissionCheckbox}
                                                      control={<Checkbox
                                                        style={{ padding: 4 }}
                                                        checked={true}
                                                        disabled />}
                                                      label={perm.appPermDisplayName}
                                                    />
                                                    <Description text={perm.appPermDescription} />
                                                    {
                                                      perm.appPermissionRequireScope ?
                                                        <div style={{ paddingLeft: 28 }}>
                                                          <label>{perm.scope == 1 ? "For user's ward only" : "For any ward in hospital"}</label>
                                                        </div> : null
                                                    }
                                                  </div>
                                                )}

                                              </div> : null}
                                            {profileFeaturesList.filter(p => p.categoryName === "Security").length > 0 ?
                                              <div style={{ borderLeft: '4px solid #B75959', paddingLeft: 20, marginTop: 30 }}>
                                                <Heading text="SECURITY" color="#B75959" />

                                                {profileFeaturesList.filter(p => p.categoryName === "Security").map((perm, i) =>
                                                  <div key={perm.applicationPermissionId}>
                                                    <FormControlLabel
                                                      className={classes.profilePermissionCheckbox}
                                                      control={<Checkbox
                                                        style={{ padding: 4 }}
                                                        checked={true}
                                                        disabled />}
                                                      label={perm.appPermDisplayName}
                                                    />
                                                    <Description text={perm.appPermDescription} />
                                                    {
                                                      perm.appPermissionRequireScope ?
                                                        <div style={{ paddingLeft: 28 }}>
                                                          <label>{perm.scope == 1 ? "For user's ward only" : "For any ward in hospital"}</label>
                                                        </div> : null
                                                    }
                                                  </div>
                                                )}

                                              </div> : null}
                                            {/*{profileFeaturesList.filter(p => p.categoryName === "PCR").length > 0 ?*/}
                                            {/*<div style={{ borderLeft: '4px solid #B75959', paddingLeft: 20, marginTop: 30 }}>*/}
                                            {/*    <Heading text="PCR" color="#B75959" />*/}

                                            {/*    {profileFeaturesList.filter(p => p.categoryName === "PCR").map((perm, i) =>*/}
                                            {/*        <div key={perm.applicationPermissionId}>*/}
                                            {/*            <FormControlLabel*/}
                                            {/*                className={classes.profilePermissionCheckbox}*/}
                                            {/*                control={<Checkbox*/}
                                            {/*                    style={{ padding: 4 }}*/}
                                            {/*                    checked={true}*/}
                                            {/*                    disabled />}*/}
                                            {/*                label={perm.appPermDisplayName}*/}
                                            {/*            />*/}
                                            {/*            <Description text={perm.appPermDescription} />*/}
                                            {/*            {*/}
                                            {/*                perm.appPermissionRequireScope ?*/}
                                            {/*                    <div style={{ paddingLeft: 28 }}>*/}
                                            {/*                        <label>{perm.scope == 1 ? "For user's ward only" : "For any ward in hospital"}</label>*/}
                                            {/*                    </div> : null*/}
                                            {/*            }*/}
                                            {/*        </div>*/}
                                            {/*    )}*/}

                                            {/*</div> : null}*/}
                                            {profileFeaturesList.filter(p => p.categoryName === "PCR").length > 0 ?
                                                                                <div style={{ borderLeft: '4px solid #AE72C0', paddingLeft: 20, marginTop: 30 }}>
                                                                                    <Heading text="PCR" color="#AE72C0" />

                                                                                    {profileFeaturesList.filter(p => p.categoryName === "PCR" && p.role === "ViewPCR" && p.appPermissionIsInternal === true).map((perm, i) =>
                                                                                        <div key={perm.applicationPermissionId}>
                                                                                             {perm.applicationPermissionName ==="SMAViewPCR" &&(<>
                                                                                            <FormControlLabel
                                                                                                className={classes.profilePermissionCheckbox}
                                                                                                control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                label={perm.appPermDisplayName}
                                                                                            />
                                                                                            <Description text={perm.appPermDescription} />
                                                                                            {
                                                                                                perm.appPermissionRequireScope ?
                                                                                                    <div style={{ paddingLeft: 28 }}>
                                                                                                        <label>{perm.scope == 1 ? "For user's ward only" : "For any ward in hospital"}</label>
                                                                                                    </div> : null
                                                                                            }
                                                                                            </>)}
                                                                                            {perm.subName ==="ViewPCR"&& perm.applicationPermissionName ==="SMAReviewPCR"  &&(<>
                                                                                                
                                                                                                <div className={"body"}>
                                                                                                    <div className={"list"}>
                                                                                                    <FormControlLabel
                                                                                                    className={classes.profilePermissionCheckbox}
                                                                                                    control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                    label={perm.appPermDisplayName}
                                                                                                         />
                                                                                                    </div>
                                                                                
                                                                                                </div>
                                                                                                </>)}
                                                                                                {perm.subName ==="ReviewPCR"&& perm.applicationPermissionName ==="SMACGReviewPCR"  &&(<>
                                                                                                
                                                                                                <div className={"body"}>
                                                                                                    <div className={"list"}>
                                                                                                    <FormControlLabel
                                                                                                    className={classes.profilePermissionCheckbox}
                                                                                                    control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                    label={perm.appPermDisplayName}
                                                                                                         />
                                                                                                    </div>
                                                                                
                                                                                                </div>
                                                                                                </>)}
                                                                                               
                                                                                        </div>
                                                                                    )}
                                                                                     {profileFeaturesList.filter(p => p.categoryName === "PCR" && p.role === "ViewPCR" && p.appPermissionIsInternal === false).map((perm, i) =>
                                                                                        <div key={perm.applicationPermissionId}>
                                                                                             {perm.applicationPermissionName ==="ViewPCR" &&(<>
                                                                                            <FormControlLabel
                                                                                                className={classes.profilePermissionCheckbox}
                                                                                                control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                label={perm.appPermDisplayName}
                                                                                            />
                                                                                            <Description text={perm.appPermDescription} />
                                                                                            {
                                                                                                perm.appPermissionRequireScope ?
                                                                                                    <div style={{ paddingLeft: 28 }}>
                                                                                                        <label>{perm.scope == 1 ? "For user's ward only" : "For any ward in hospital"}</label>
                                                                                                    </div> : null
                                                                                            }
                                                                                            </>)}
                                                                                            {perm.subName ==="ViewPCR" && perm.applicationPermissionName ==="ReviewPCR" &&(<>
                                                                                                
                                                                                                <div className={"body"}>
                                                                                                    <div className={"list"}>
                                                                                                    <FormControlLabel
                                                                                                    className={classes.profilePermissionCheckbox}
                                                                                                    control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                    label={perm.applicationPermissionName}
                                                                                                         />
                                                                                                    </div>
                                                                                
                                                                                                </div>
                                                                                                </>)}
                                                                                                {perm.subName ==="ReviewPCR" && perm.applicationPermissionName ==="CGReviewPCR" &&(<>
                                                                                                
                                                                                                <div className={"body"}>
                                                                                                    <div className={"list"}>
                                                                                                    <FormControlLabel
                                                                                                    className={classes.profilePermissionCheckbox}
                                                                                                    control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                    label={perm.appPermDisplayName}
                                                                                                         />
                                                                                                    </div>
                                                                                
                                                                                                </div>
                                                                                                </>)}
                                                                                               
                                                                                        </div>
                                                                                    )}
                                                                                    {profileFeaturesList.filter(p => p.categoryName === "PCR" && p.role !== "ViewPCR").map((perm, i) =>
                                                                                        <div key={perm.applicationPermissionId}>
                                                                                            <FormControlLabel
                                                                                                className={classes.profilePermissionCheckbox}
                                                                                                control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                label={perm.appPermDisplayName}
                                                                                            />
                                                                                            <Description text={perm.appPermDescription} />
                                                                                            {
                                                                                                perm.appPermissionRequireScope ?
                                                                                                    <div style={{ paddingLeft: 28 }}>
                                                                                                        <label>{perm.scope == 1 ? "For user's ward only" : "For any ward in hospital"}</label>
                                                                                                    </div> : null
                                                                                            }                                                                                                                                                                  
                                                                                        </div>
                                                                                    )}
                                                                                </div> : null}
                                            {profileFeaturesList.filter(p => p.categoryName === "Medical Response").length > 0 ?
                                              <div style={{ borderLeft: '4px solid #AE72C0', paddingLeft: 20, marginTop: 30 }}>
                                                <Heading text="MEDICAL RESPONSE" color="#AE72C0" />

                                                {profileFeaturesList.filter(p => p.categoryName === "Medical Response").map((perm, i) =>
                                                  <div key={perm.applicationPermissionId}>
                                                    <FormControlLabel
                                                      className={classes.profilePermissionCheckbox}
                                                      control={<Checkbox
                                                        style={{ padding: 4 }}
                                                        checked={true}
                                                        disabled />}
                                                      label={perm.appPermDisplayName}
                                                    />
                                                    <Description text={perm.appPermDescription} />
                                                    {
                                                      perm.appPermissionRequireScope ?
                                                        <div style={{ paddingLeft: 28 }}>
                                                          <label>{perm.scope == 1 ? "For user's ward only" : "For any ward in hospital"}</label>
                                                        </div> : null
                                                    }
                                                  </div>
                                                )}
                                              </div> : null}
                                          </React.Fragment>

                                          : (
                                            <React.Fragment>
                                              <Skeleton variant="rect" width="100%" height={118} />
                                              <Skeleton variant="text" />
                                              <Skeleton variant="rect" width="100%" height={118} />
                                              <Skeleton variant="text" />
                                              <Skeleton variant="rect" width="100%" height={118} />
                                            </React.Fragment>
                                          )
                                      }
                                    </DialogContent>
                                    <DialogActions>
                                      <Button variant="contained" fullWidth onClick={handleUserProfileDialogClose} color="primary">
                                        Done
                                      </Button>
                                    </DialogActions>
                                  </Dialog>
                                </div>
                              )}
                              rules={{
                                required: "User profile is required",
                                validate: validateUserProfile,
                              }}
                            />
                          </Grid>
                          {locationListhidden?
                          <Grid item xs={12}>
                            <div className={classes.textFieldLable}>LOCATION</div>
                            <Controller
                              name='locationId'
                              defaultValue=''
                              control={control}
                              render={({ onChange, onBlur, value, name }) => (
                                <Select
                                  error={errors.locationId}
                                  onChange={e => selectChangedHandler(e.target.value, 'locationId')}
                                  className={classes.selectField}
                                  fullWidth={true}
                                  displayEmpty
                                  defaultValue=''                               
                                  IconComponent={KeyboardArrowDownIcon}
                                  value={value}
                                  variant="outlined">
                                  <MenuItem key="None" value={''}>None</MenuItem >
                                  {
                                    editUser ?
                                      locationList.filter(c => c.disabled == false || c.value == value).map(item => <MenuItem disabled={item.disabled} selected={item.selected}
                                        key={item.value} defaultValue={item.value} value={item.value}>{item.text}</MenuItem>)
                                      :
                                      locationList.filter(l => l.disabled == false).map(item => <MenuItem disabled={item.disabled} selected={item.selected}
                                        key={item.value} defaultValue={item.value} value={item.value}>{item.text}</MenuItem>)
                                  }
                                </Select>
                              )}
                            // rules={{

                            //     validate: (value: string) => {
                            //         let values = getValues();
                            //         if (values["customerId"]) {
                            //             if (!value) {
                            //                 return "Location is required if customer is selected";
                            //             }
                            //         }
                            //         return true;
                            //     }
                            // }}
                            />
                            <FormHelperText className={classes.helpText}>{errors.locationId ? errors.locationId.message : ''}</FormHelperText>
                          </Grid>:null}
                          {wardhidden?
                          <Grid item xs={12}>
                            <div className={classes.textFieldLable}>WARD</div>
                            <Controller
                              name="wardId"
                              defaultValue=""
                              control={control}
                              render={({ onChange, onBlur, value, name }) => (

                                <Select error={errors.wardId} className={classes.selectField} fullWidth={true} value={value}
                                  onChange={(e) => {
                                    onChange(e);
                                  }}
                                  IconComponent={KeyboardArrowDownIcon} displayEmpty defaultValue="" variant="outlined">
                                  <MenuItem key="None" value={""}>
                                    None
                                  </MenuItem>
                                  {
                                    wardList.map(item => <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>{item.text}</MenuItem>)
                                  }
                                </Select>

                              )}
                            // rules={{

                            //     validate: validateWard,
                            // }}
                            />
                            <FormHelperText className={classes.helpText}>{errors.wardId ? errors.wardId.message : ""}</FormHelperText>
                          </Grid>:null}
                          <Grid item xs={12} />
                          <Grid item xs={12}>
                            <div>
                              <div className={classes.textFieldLable}>USER STATUS</div>
                              <Controller
                                render={(props) => (
                                  <RadioGroup row aria-label="position" defaultValue="top">
                                    <FormControlLabel
                                      value="Enabled"
                                      control={<Radio color="primary" />}
                                      label="Enabled"
                                      onChange={(e) => {
                                        setUserStatus(true);
                                      }}
                                      checked={userStatus}
                                    />
                                    <FormControlLabel
                                      value="Disabled"
                                      control={<Radio color="primary" />}
                                      label="Disabled"
                                      onChange={(e) => {
                                        setUserStatus(false);
                                      }}
                                      checked={!userStatus}
                                    />
                                  </RadioGroup>
                                )}
                                defaultValue=""
                                name="isEnabled"
                                control={control}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={12}>
                            <div>
                              <div className={classes.textFieldLable}>Enable 2FA</div>
                              <Controller
                                render={(props) => (
                                  <RadioGroup row aria-label="position" defaultValue="top">
                                    <FormControlLabel
                                      value={true}
                                      control={<Radio color="primary" />}
                                      label="Enable"
                                      onChange={(e) => {
                                        setEnable2FA(true);
                                      }}
                                      checked={enable2FA}
                                    />
                                    <FormControlLabel
                                      value={false}
                                      control={<Radio color="primary" />}
                                      label="Disable"
                                      onChange={(e) => {
                                        setEnable2FA(false);
                                      }}
                                      checked={!enable2FA}
                                      style={{ marginLeft: 3 }}
                                    />
                                  </RadioGroup>
                                )}
                                defaultValue=""
                                name="enable2FA"
                                control={control}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={12} />
                          <Grid item xs={12}>
                            <div className={classes.textFieldLable}>
                              <span>
                                <StarIcon />
                              </span>
                              EMAIL ADDRESS
                            </div>
                            <Controller
                              control={control}
                              as={
                                <TextField
                                  classes={{ root: classes.textFieldRoot }}
                                  InputProps={{
                                    classes: { root: classes.textFieldInput },
                                  }}
                                  variant="outlined"
                                  error={errors.emailAddress}
                                  helperText={errors.emailAddress ? errors.emailAddress.message : ""}
                                />
                              }
                              name="emailAddress"
                              defaultValue=""
                              rules={{
                                required: "Email Address is required",
                                pattern: {
                                  value: consts.EmailRegex,
                                  message: "Invalid email address",
                                },
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} />
                          {isIndividualAccount ? (
                            <Grid item xs={12}>
                              <Box className={classes.textFieldLable}>MOBILE PHONE</Box>
                              <Controller
                                control={control}
                                as={
                                  <TextField
                                    classes={{ root: classes.textFieldRoot }}
                                    InputProps={{
                                      classes: { root: classes.textFieldInput },
                                    }}
                                    variant="outlined"
                                    error={errors.phoneNumber}
                                    helperText={errors.phoneNumber ? errors.phoneNumber.message : ""}
                                  />
                                }
                                name="phoneNumber"
                                defaultValue=""
                                rules={{
                                  pattern: {
                                    value: /^[0-9\s\-]{5,20}$/,
                                    message: "Invalid phone number",
                                  },
                                }}
                              />
                            </Grid>
                          ) : editUser ? null : (
                            <Grid item xs={12}>
                              <Box>
                                <Box className={classes.textFieldLable}>
                                  <span>
                                    <StarIcon />
                                  </span>
                                  PASSWORD
                                </Box>
                                <Controller
                                  defaultValue=""
                                  control={control}
                                  render={({ onChange, onBlur, value, name }) => (
                                    <TextField
                                      classes={{ root: classes.textFieldRoot }}
                                      InputProps={{
                                        classes: {
                                          root: classes.textFieldInput,
                                        },
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <IconButton style={{ color: "#000" }} aria-label="toggle password visibility" onClick={cg_handleClickShowPassword} onMouseDown={cg_handleMouseDownPassword}>
                                              {cg_showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                          </InputAdornment>
                                        ),
                                      }}
                                      onBlur={onBlur}
                                      value={value}
                                      name={name}
                                      onChange={(e) => {
                                        let pwdStrength = getPasswordStrength(e.target.value);
                                        setResetPasswordStrength(pwdStrength);
                                        onChange(e);
                                      }}
                                      variant="outlined"
                                      type={cg_showPassword ? "text" : "password"}
                                      error={errors.password}
                                      helperText={errors.password ? errors.password.message : ""}
                                    />
                                  )}
                                  name="password"
                                  rules={{
                                    required: "Password is required",
                                    validate: (value) => {
                                      let pwdStrength = getPasswordStrength(value);
                                      if (pwdStrength !== PasswordStrength.good) {
                                        return false;
                                      } else {
                                        return true;
                                      }
                                    },
                                  }}
                                />
                              </Box>
                              {GeneratePassword("edit")}
                            </Grid>
                          )}
                          <Grid item xs={12}>
                            <Box className={classes.textFieldLable}>EMPLOYEE ID</Box>
                            <Controller
                              control={control}
                              as={
                                <TextField
                                  classes={{ root: classes.textFieldRoot }}
                                  InputProps={{
                                    classes: { root: classes.textFieldInput },
                                  }}
                                  variant="outlined"
                                  error={errors.employeeId}
                                  type="number"
                                  helperText={errors.employeeId ? errors.employeeId.message : ""}
                                />
                              }
                              name="employeeId"
                              defaultValue=""

                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
              <div className={classes.main} style={{ paddingLeft: 40, paddingRight: 40 }}>
                <div className={classes.headingAlert}>
                  <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" classes={{ root: classes.alertRoot }} style={{ display: errorMessage ? "flex" : "none" }}>
                    {errorMessage}
                  </Alert>
                  <Alert variant="filled" severity="success" classes={{ root: classes.alertRoot }} style={{ display: statusMessage ? "flex" : "none" }}>
                    {statusMessage}
                  </Alert>
                </div>
              </div>

              {loading ? <CreateLoadingLine /> : <HorizontalLine />}
              <div className={classes.btnContainer}>
                <div className={classes.formLeft}>
                  <Button className={classes.saveBtn} variant="contained" type="submit">
                    {editUser ? "Update" : "Save"}
                  </Button>
                  <Button className={classes.cancelBtn} variant="contained" onClick={goToUsers}>
                    Cancel
                  </Button>
                </div>
                <div>
                  {editUser ? <Button className={classes.changePasswordBtn} variant="contained" onClick={handleOpen}>Change Password</Button> : null}
                </div>
              </div>
            </form>
          </Box>
        </Paper>
      </MuiThemeProvider>
    </React.Fragment>
  );
};

export default AddEditUserWidget;
